import { CheckCircle2, Loader2, RefreshCw, ShieldAlert } from 'lucide-react';
import { UNIONPAY_B2B_CODE } from './paymentChannels';

export default function PaymentChannelReadiness({
  channel,
  status = 'ready',
  onRetry,
  english = false,
}) {
  if (channel?.code !== UNIONPAY_B2B_CODE) return null;

  const loading = status === 'loading';
  const failed = status === 'error';
  const ready = status === 'ready' && channel.enabled;

  return (
    <section
      className={`billing-channel-readiness is-${loading ? 'loading' : failed ? 'error' : ready ? 'ready' : 'blocked'}`}
      role={failed ? 'alert' : 'status'}
      aria-live="polite"
    >
      <div className="billing-channel-readiness__heading">
        <span aria-hidden="true">
          {loading ? <Loader2 className="is-spinning" size={15} /> : ready ? <CheckCircle2 size={15} /> : <ShieldAlert size={15} />}
        </span>
        <div>
          <strong>{loading
            ? (english ? 'Checking payment availability' : '正在检查支付是否可用')
            : failed
              ? ('暂时无法读取通道状态')
              : ready
                ? (english ? 'Ready for test payment' : '可发起测试支付')
                : ('企业网银暂不可用')}</strong>
          <p>{failed
            ? ('暂时无法确认支付状态，请重试后再提交订单。')
            : loading
              ? (english ? 'Please wait before submitting an order.' : '请稍候再提交订单。')
              : ready
                ? (english ? 'Confirm the order to open the test cashier.' : '确认订单后可进入测试收银台。')
                : ('当前无法使用此方式提交订单，请稍后重试。')}</p>
        </div>
        {failed && onRetry && (
          <button type="button" onClick={onRetry}>
            <RefreshCw size={12} />{english ? 'Retry' : '重新检查'}
          </button>
        )}
      </div>
    </section>
  );
}
